import { useCallback, useEffect, useState } from "react";
import { getAnalyseVenteParType } from "../../../../services/rapportService";

const useCouleurMarqueData = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        top_couleurs: [],
        top_matieres: [],
        top_categories: [],
        analyse_croisee: [],
        recommandations_achat: [],
        tableau_bord: []
    });
    const [filters, setFilters] = useState({});

    const fetchDatas = useCallback(async (filterParams = {}) => {
        try {
            setLoading(true);
            
            const params = {
                ...filterParams
            };
            
            // Normalisation des filtres multiples
            if (params.id_marque && Array.isArray(params.id_marque)) {
                params.id_marque = params.id_marque.join(',');
            }
            if (params.id_taille && Array.isArray(params.id_taille)) {
                params.id_taille = params.id_taille.join(',');
            }
            if (params.id_categorie && Array.isArray(params.id_categorie)) {
                params.id_categorie = params.id_categorie.join(',');
            }
            if (params.id_couleur && Array.isArray(params.id_couleur)) {
                params.id_couleur = params.id_couleur.join(',');
            }
            if (params.id_matiere && Array.isArray(params.id_matiere)) {
                params.id_matiere = params.id_matiere.join(',');
            }
            
            const response = await getAnalyseVenteParType(params);
            
            if (response.data && response.data.data) {
                setData({
                    top_couleurs: response.data.data.top_couleurs || [],
                    top_matieres: response.data.data.top_matieres || [],
                    top_categories: response.data.data.top_categories || [],
                    analyse_croisee: response.data.data.analyse_croisee || [],
                    recommandations_achat: response.data.data.recommandations_achat || [],
                    tableau_bord: response.data.data.tableau_bord || []
                });
            } else {
                setData({
                    top_couleurs: [],
                    top_matieres: [],
                    top_categories: [],
                    analyse_croisee: [],
                    recommandations_achat: [],
                    tableau_bord: []
                });
            }
            
            setFilters(filterParams);
            
        } catch (error) {
            console.error("Erreur lors du chargement des données:", error);
            setData({
                top_couleurs: [],
                top_matieres: [],
                top_categories: [],
                analyse_croisee: [],
                recommandations_achat: [],
                tableau_bord: []
            });
        } finally {
            setLoading(false);
        }
    }, []);

    const refreshWithFilters = useCallback((newFilters) => {
        fetchDatas(newFilters);
    }, [fetchDatas]);

    useEffect(() => {
        fetchDatas({});
    }, [fetchDatas]);

    return {
        data,
        loading,
        filters,
        fetchDatas,
        refreshWithFilters
    };
};

export default useCouleurMarqueData;